import React, { useState } from "react";
import FormField from "../FormField/FormField";
import ProgressBar from "../../Components/ProgressBar/ProgressBar";
import shared from "../../styles/shared.module.css";
import { validateFields } from "../../Utilities/validateStep";
import { step3Fields } from "../../data/formFields";

const PROGRAM_HEADING = {
  volunteer: "GLOBAL VOLUNTEER",
  intern: "GLOBAL TALENT",
  teach: "GLOBAL TEACHER",
};

function Step3({ data, updateData, onNext, onBack }) {
  const [errors, setErrors] = useState([]);

  const heading =
    data.educationLevel === "undergraduate"
      ? "GLOBAL VOLUNTEER"
      : PROGRAM_HEADING[data.opportunityType] || "GLOBAL EXCHANGES";

  const handleSubmit = (e) => {
    e.preventDefault();
    try {
      const fieldErrors = validateFields(step3Fields, data);
      if (fieldErrors.length > 0) {
        setErrors(fieldErrors);
        return;
      }
      setErrors([]);
      onNext();
    } catch (err) {
      console.error(err);
      setErrors(["Something went wrong — please check the console and try again."]);
    }
  };

  return (
    <>
      <h1 className={shared.pageHeading}>{heading}</h1>
      <p className={shared.pageSubheading}>Almost there. Help us understand your background and what drives you.</p>
      <ProgressBar currentStep={3} totalSteps={3} />

      <form onSubmit={handleSubmit}>
        <div className={shared.cardStack}>
          {step3Fields.map((field) => (
            <div key={field.name} className={shared.questionCard}>
              <FormField field={field} value={data[field.name]} onChange={updateData} />
            </div>
          ))}
        </div>

        {errors.length > 0 && (
          <ul className={shared.errorList}>
            {errors.map((err) => <li key={err}>{err}</li>)}
          </ul>
        )}

        <div className={shared.navRow}>
          <button type="button" className={shared.secondaryButton} onClick={onBack}>← Back</button>
          <button type="submit" className={shared.primaryButton}>Review Application →</button>
        </div>
      </form>
    </>
  );
}

export default Step3;
